import React from 'react';

import Paper from '~/components/core/Atomic/Paper';
import UserClaimsNotifications from '~/components/UserClaimsNotificationsContainer';

const DismissedNotificationsPage: React.FC = () => {
  return (
    // The <Paper> is needed for the scroll to work
    <Paper>
      <UserClaimsNotifications onlyDismissed />
    </Paper>
  );
};

export default DismissedNotificationsPage;
